import { useState } from "react";
import { Clapperboard, Loader2 } from "lucide-react";
import { http, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function LoginPage() {
  const { setUser } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { const { data } = await http.post("/auth/login", f); setUser(data); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="login-page">
      <form onSubmit={submit} className="panel w-full max-w-sm p-8 space-y-5 fade-up">
        <div className="flex items-center gap-2 text-amber-400 font-mono text-xs tracking-widest"><Clapperboard className="w-4 h-4" /> EPISODE STUDIO</div>
        <div>
          <h1 className="font-display text-3xl font-semibold">Sign in</h1>
          <p className="text-sm text-slate-400 mt-1">This studio is private. Only the admin can open it.</p>
        </div>
        <Input data-testid="login-email-input" type="email" autoComplete="username" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <Input data-testid="login-password-input" type="password" autoComplete="current-password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
        <Button data-testid="login-submit-btn" type="submit" disabled={busy || !f.email || !f.password} className="w-full rounded-full">
          {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Sign in
        </Button>
      </form>
    </div>
  );
}
